import { provideRouter, Routes } from '@angular/router';
import { ROUTES_MAIN } from './common/enums/routes-main.enum';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { ROUTES_AUTH } from './modules/auth/enums/routes-auth.enum';
import { ROUTES_DASHBOARD } from './common/enums/routes-dashboard.enum';
import { sessionExistGuard, sessionNotExistGuard } from '@common/guards/session.guard';
import { PermissionRoleResolver } from './modules/profile/resolvers/permission-role.resolver';
import { UserProfileResolver } from './modules/profile/resolvers/user-profile.resolver';

const APP_ROUTING: Routes = [
  {
    path: ROUTES_MAIN.AUTH,
    canActivate: [sessionNotExistGuard],
    loadChildren: () => import('./modules/auth/auth.routing')
  },
  {
    path: ROUTES_MAIN.DASHBOARD,
    component: DashboardComponent,
    canActivate: [sessionExistGuard],
    resolve: {
      profile: UserProfileResolver,
      permissions: PermissionRoleResolver
    },
    children: [
      {
        path: ROUTES_DASHBOARD.STADISTICS,
        loadChildren: () => import('./modules/stadistics/stadistics.routing')
      },
      {
        path: ROUTES_DASHBOARD.USERS,
        loadChildren: () => import('./modules/users/users.routing')
      },
      {
        path: ROUTES_DASHBOARD.OFFICES,
        loadChildren: () => import('./modules/offices/offices.routing')
      },
      {
        path: ROUTES_DASHBOARD.PROFILE,
        loadChildren: () => import('./modules/profile/profile.routing')
      },
      {
        path: ROUTES_DASHBOARD.CONTRACTS,
        loadChildren: () => import('./modules/contracts/contract.routing')
      },
      {
        path: ROUTES_DASHBOARD.OPERATIONS,
        loadChildren: () => import('./modules/operations/operations.routing')
      },
      {
        path: ROUTES_DASHBOARD.TEAMS,
        loadChildren: () => import('./modules/teams/teams.routing')
      },
      {
        path: ROUTES_DASHBOARD.PROSPECTION,
        loadChildren: () => import('./modules/prospection/prospection.routing')
      },
      {
        path: ROUTES_DASHBOARD.MANAGEMENT,
        loadChildren: () => import('./modules/management/management.routing')
      },
      {
        path: ROUTES_DASHBOARD.LIQUIDATIONS,
        loadChildren: () => import('./modules/liquidaciones/liquidaciones.routing')
      },
      {
        path: ROUTES_DASHBOARD.TOOLS,
        loadChildren: () => import('./modules/service-test/service-test.routing')
      },
      //agregar aqui la logica de redireccionamiento a la ruta de estadisticas o a la de my-day del comercial o al de my-day del gerente
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ROUTES_DASHBOARD.STADISTICS
      }
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: [ROUTES_MAIN.AUTH, ROUTES_AUTH.LOGIN].join('/')
  },
  {
    path: '**',
    redirectTo: [ROUTES_MAIN.AUTH, ROUTES_AUTH.LOGIN].join('/')
  }
];

export default APP_ROUTING;
